import { AuditFormFieldController } from './audit-form-field.controller'

function auditFormField () {
  return {
    restrict: 'E',
    scope: {
      field: '=',
      order: '<',
      last: '<',
      disabled: '<',
      readOnly: '<',
      showScore: '<',
      auditStatus: '<',
      showNonconformities: '<',
      uploadedFiles: '='
    },
    templateUrl: '/audit/directives/audit-form-field/audit-form-field-directive.html?$$REVISION$$',
    controller: AuditFormFieldController
  }
}

export { auditFormField }
